import { UploadRegularIcon } from "@elixir/icons";
import { Dropdown, Menu } from "antd";
import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import { ChipWithTooltip } from "ui";
import { onUploadMedicalRecordEvent } from "../../../../utils/bridges/methods";
import { getAclViewClassName } from "@elixir/utils";

const UploadMedicalRecord = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const handleUploadFile = () => {
    onUploadMedicalRecordEvent(apt.patient_oid, { source: "file" });
  };

  const handleTakePicture = () => {
    onUploadMedicalRecordEvent(apt.patient_oid, { source: "camera" });
  };

  const menu = (
    <Menu>
      <Menu.Item key="file" onClick={handleUploadFile}>
        Upload file
      </Menu.Item>
      <Menu.Item key="camera" onClick={handleTakePicture}>
        Take picture
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomLeft">
      <div>
        <ChipWithTooltip
          onClick={() => {}}
          className={`${className} ${getAclViewClassName(
            SUBJECT_KEYS.UPLOAD_MEDICAL_RECORDS
          )}`}
          icon={
            <UploadRegularIcon className="dr-min-w-12 dr-w-12 dr-h-12 dr-text-darwin-primary-primary" />
          }
          title="Upload Medical Records"
          tooltipText="Upload Medical Records"
          type={type}
          iconOnly={true}
        />
      </div>
    </Dropdown>
  );
};

export default UploadMedicalRecord;
